export const notificationsPaths = {
  list: '/notifications',
} as const;
